module.exports = __webpack_public_path__ + "static/media/backreact.f8fd645e.jpg";